import { Component, ElementRef, HostListener, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { UrlService } from '../../services/url.service';
import { AmenitiesService } from '../../services/amenities.service';
import { ApiClientService } from '../../services/api-client.service';
import { SettingsAmenitiesService } from '../../services/settings-amenities.service';
import { AuthenticationService } from '../../services/authentication.service';

declare const toastr: any;

@Component({
    selector: 'amenities-filter',
    templateUrl: './amenities-filter.component.html',
    styleUrls: ['./amenities-filter.component.scss']
})
export class AmenitiesFilterComponent implements OnInit {
    showDropdown = false;
    @Output() onAmenitiesChange: EventEmitter<any> = new EventEmitter();

    @ViewChild('approvedCheckbox') approved: ElementRef;
    @ViewChild('pendingCheckbox')  pending:  ElementRef;
    @ViewChild('expiredCheckbox')  expired:  ElementRef;
    @ViewChild('declinedCheckbox') declined: ElementRef;
    amenities: Array<any> = [];
    spinnerShow = true;
    amenityForColorChanging = null;
    timeoutForFilterChanging = null;
    colorPallet = ['#ff5027', '#fc2d61', '#a42eb5', '#6940bd', '#3951bb', '#3e9f46', '#008689',
                   '#00aad9', '#009bfc', '#028cfa', '#83b63b', '#ccd118', '#ffe10c', '#ffbb01',
                   '#ff9901', '#000000', '#5d798b', '#9d9d9f', '#7b5844', '#ff6100'];
    constructor(private urlService: UrlService,
        public amenitiesService: AmenitiesService,
        public settingsAmenitiesService: SettingsAmenitiesService,
        public api: ApiClientService,
        public authenticationService: AuthenticationService,
    ) { }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const status = this.urlService.queryParams['status'];
            if (status) {
                this.approved.nativeElement.checked = status.indexOf('approved') !== -1;
                this.pending.nativeElement.checked = status.indexOf('pending') !== -1;
                this.expired.nativeElement.checked = status.indexOf('expired') !== -1;
                this.declined.nativeElement.checked = status.indexOf('declined') !== -1;
            } else {
                this.approved.nativeElement.checked = false;
                this.pending.nativeElement.checked = false;
                this.expired.nativeElement.checked = false;
                this.declined.nativeElement.checked = false;
            }
            this.spinnerShow = false;
            this.amenitiesService.amenitiesList.filter((amenity) => {
                const queryParams = this.urlService.getQueryParamsJson();

                if(!_.amenity_id) {
                    amenity.checked = false;
                    const checkboxes = (<any>document.getElementsByClassName('amenities-filter-items-wrapper')[0]).childNodes;
                    for(let i = 0; i < checkboxes.length; i++) {
                        if(checkboxes[i].classList && checkboxes[i].classList.value.indexOf('filter-checkbox') != -1) {
                            checkboxes[i].childNodes[1].childNodes[1].checked = false;
                        }
                    }
                }
                const selectedAmenities = Array.isArray(queryParams['amenity_id']) ? queryParams['amenity_id'] : [queryParams['amenity_id']];
                if (selectedAmenities && selectedAmenities.indexOf((amenity.id).toString()) != -1) {
                    amenity.checked = true;
                    this.onAmenitiesChange.emit(amenity);
                } else
                    amenity.checked = false;
            });
        });
    }

    changeFilter() {
        const approvedValue = this.approved.nativeElement.checked;
        const pendingValue = this.pending.nativeElement.checked;
        const expiredValue = this.expired.nativeElement.checked;
        const declinedValue = this.declined.nativeElement.checked;

        this.urlService.queryParams['amenity_id'] = [];
        const checkboxes = (<any>document.getElementsByClassName('amenities-filter-items-wrapper')[0]).childNodes;
        for(let i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].classList && checkboxes[i].classList.value.indexOf('filter-checkbox') != -1) {
                if(checkboxes[i].childNodes[1].childNodes[1].checked)
                    this.urlService.queryParams['amenity_id'].push(checkboxes[i].childNodes[1].childNodes[1].id);
            }
        }

        if (!approvedValue && !pendingValue && !expiredValue && !declinedValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (approvedValue) status += 'approved,';
            if (pendingValue) status += 'pending,';
            if (expiredValue) status += 'expired,';
            if (declinedValue) status += 'declined,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }
        this.urlService.setQueryParams(null, 1);
        this.amenitiesService.getData();
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('amenities-filter') &&
            (<any>targetElement.classList).value != 'cdk-overlay-backdrop' &&
            (<any>targetElement.classList).value != 'bookings-filter-colors-table-item') this.showDropdown = false;
    }

    updateAmenityColor(color): void {
        const data = {
            timeSequenceType: this.amenityForColorChanging.timeSequenceType,
            amenityColor: color
        };
        this.amenitiesService.calendarSpinnerShow = true;
        const url = `/v1/amenity/${this.amenityForColorChanging.id}.json`;
        this.settingsAmenitiesService.api.patch('domainAmenities', url, data).subscribe(
            () => this.updateView('The Color was successfully updated', color),
            (error) => {
                this.api.errorHandler(error, 'Update failed!');
                this.amenitiesService.calendarSpinnerShow = false;
            }
        );
    }

    updateView(msg: string, color): void {
        toastr.success(msg);
        this.amenitiesService.updateAmenityColor(this.amenityForColorChanging.id, color);
        this.amenitiesService.calendarSpinnerShow = false;
        this.amenityForColorChanging.amenityColor = color;
    }

    timeOutBeforeFilterChanging(): void {
        if(this.timeoutForFilterChanging)
            clearTimeout(this.timeoutForFilterChanging);
        this.timeoutForFilterChanging = setTimeout(() => this.changeFilter(), 1000);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/amenities-filter/amenities-filter.component.ts